import React from 'react';
import PropTypes from 'prop-types';
import util from 'Utils/commonUtil';
// Components
import BasicButton from 'Components/common/BasicButton';

class DynamicCounter extends React.Component {
    state = {
        value: '',
    };
    isFocus = false;
    timer = null;
    reduceBtnDisabled = false;
    plusBtnDisabled = false;

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.defalutValue !== this.props.defalutValue) {
            this.checkBtnDisabled(this.props.defalutValue);
            this.setState({value: this.props.defalutValue});
        }
        if (prevState.value !== this.state.value) {
            this.checkBtnDisabled(this.state.value);

            if (util.isFunction(this.props.inputValid)) {
                this.props.inputValid(this.state.value);
            }
        }
    }

    componentWillMount() {
        if (this.state.value === '') {
            this.checkBtnDisabled(this.props.defalutValue);
            this.setState({value: this.props.defalutValue});
        }
    }

    /**
     * Update value.
     */
    onChange = (ev) => {
        let value = ev.target.value.replace(/([^0-9]*)/g, '');
        // const { options } = this.props;

        this.setState({value});
    };

    onFocus = () => {
        if (util.isFunction(this.props.onFocus)) {
            this.props.onFocus();
        }
    };

    onBlur = () => {
        const {value} = this.state;
        const {options} = this.props;

        if (util.isNumber(options.min) && options.min > value) {
            this.setState({value: options.min});
        }
        if (util.isNumber(options.max) && options.max < value) {
            this.setState({value: options.max});
        }

        if (value === '' || value === null || value === undefined) {
            this.setState({value: options.min});
        }

        if (util.isFunction(this.props.onBlur)) {
            this.props.onBlur();
        }
    };

    reduce = () => {
        let value = this.state.value && parseInt(this.state.value);

        // value -= value <= this.state.value ? value : (value + value)
        // if (value === this.props.numberSteps) {
        //     value = this.props.numberSteps;
        // } else {
        //     value -= this.props.numberSteps;
        // }
        value -= this.props.numberSteps;

        this.setState({value});

        // Run props inputValid.
        if (util.isFunction(this.props.inputValid)) {
            this.props.inputValid(value);
        }
    };

    plus = () => {
        let value = this.state.value && parseInt(this.state.value);
        console.log(
            'typeof this.props.numberSteps======',
            typeof this.props.numberSteps,
        );
        console.log('typeof value======', typeof value);
        console.log(
            'this.props.numberSteps======',
            this.props.numberSteps,
            value,
        );
        value += this.props.numberSteps;

        this.setState({value});

        // Run props inputValid.
        if (util.isFunction(this.props.inputValid)) {
            this.props.inputValid(value);
        }
    };

    checkBtnDisabled = (value) => {
        let options = this.props.options || {};

        if (util.isNumber(options.min) && options.min >= value) {
            this.reduceBtnDisabled = true;
            value = options.min;
        } else {
            this.reduceBtnDisabled = false;
        }
        if (util.isNumber(options.max) && options.max <= value) {
            this.plusBtnDisabled = true;
            value = options.max;
        } else {
            this.plusBtnDisabled = false;
        }
    };

    render() {
        const options = this.props.options || {};
        let reduceBtnDisabled = util.isBoolean(options.reduceBtnDisabled)
            ? options.reduceBtnDisabled
            : this.reduceBtnDisabled;
        let plusBtnDisabled = util.isBoolean(options.plusBtnDisabled)
            ? options.plusBtnDisabled
            : this.plusBtnDisabled;
        const {disabledFlag} = this.props;

        return (
            <div className="counter-box">
                <BasicButton
                    className="reduce-btn"
                    type="default"
                    disabled={reduceBtnDisabled ? true : disabledFlag}
                    onClickOfSingleTap={this.reduce}>
                    -
                </BasicButton>
                <input
                    ref="input"
                    disabled={disabledFlag}
                    testid={this.props.testid ? this.props.testid : ''}
                    className="input"
                    type="text"
                    value={this.state.value}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onChange={this.onChange}
                />
                <BasicButton
                    className="plus-btn"
                    type="default"
                    disabled={plusBtnDisabled ? true : disabledFlag}
                    onClickOfSingleTap={this.plus}>
                    +
                </BasicButton>
            </div>
        );
    }
}

DynamicCounter.propTypes = {
    inputValid: PropTypes.func.isRequired,
    options: PropTypes.object,
};

export default DynamicCounter;
